import { z } from 'zod';
import { emailSchema, timestampSchema, agreementsSchema, requestIdSchema, bankAccountSchema, singleRepresentativeSchema, preLimitSchema, loanLimitMerchantSchema, loanSchema, paymentTransferSchema, logoSchema, offerSchema, addressSchema, apiResponseType, providerType, companyType, loanResponseConfigParametersNames, hashType, beneficiarySchema, merchantUser, } from '@repo/shared/types';
var merchantDetails = z.object({
    name: z.string(),
    vat: z.string(),
    companyType: companyType,
    mcc: z.string(),
    pos: z.string(),
    mid: z.string(),
    phone: z.string(),
    email: emailSchema,
    representative: z.array(singleRepresentativeSchema),
    bankAccount: z.array(bankAccountSchema),
    user: merchantUser,
    activity: z.boolean(),
    shops: z.array(z.object({
        id: z.number(),
        name: z.string(),
    })),
    mvm: z.boolean(),
    address: addressSchema,
    beneficiary: beneficiarySchema,
    companyRegisterDate: z.string(),
});
var _agreementData = z.object({
    provider: providerType,
    accepted: z.boolean(),
    timestamp: timestampSchema,
});
var data = z.object({
    merchantData: merchantDetails,
    preLimits: z.array(preLimitSchema),
    limits: z.array(loanLimitMerchantSchema),
    loans: z.array(loanSchema),
    agreements: agreementsSchema.nullable(),
    transfers: z.array(paymentTransferSchema),
    offers: z.array(offerSchema),
});
var config = z.object({
    active: z.boolean(),
    provider: providerType,
    companyType: companyType,
    default: z.boolean(),
    discountEnabled: z.boolean(),
    parameters: z.array(z.object({
        name: loanResponseConfigParametersNames,
        editable: z.boolean(),
    })),
    logo: logoSchema,
});
export var merchantSchema = z.object({
    hashType: hashType,
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: apiResponseType,
    currentProvider: z.array(providerType),
    data: data,
    config: z.array(config),
});
var baseErrorSchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: apiResponseType,
});
// Response code 401
export var merchantInvalidSignErrorSchema = z
    .object({
    errorDescription: z.string(),
})
    .extend(baseErrorSchema.shape);
// Response code 500
export var merchantInternalErrorSchema = z
    .object({
    errorDescription: z.string(),
})
    .extend(baseErrorSchema.shape);
